import { RefObject } from 'react'
import { List, Paper, Popover } from '@mui/material'

import { GridPopperListItem } from './grid-popper-list-items.component'
import { IGridPopperListItem } from 'src/types'

interface IGridPopperProps {
  open: boolean
  anchorRef: RefObject<HTMLButtonElement>
  handleClose: () => void
  items: IGridPopperListItem[]
}

const GridPopper = ({ anchorRef, open, handleClose, items }: IGridPopperProps) => {
  return (
    <Popover
      open={open}
      anchorEl={anchorRef.current}
      onClose={handleClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
    >
      <Paper>
        <List disablePadding>
          {items.map((item) => (
            <GridPopperListItem key={item.title} item={item} handleClose={handleClose} />
          ))}
        </List>
      </Paper>
    </Popover>
  )
}

export { GridPopper }
